import { state } from '../../state'
import { updateEntities } from './admin-entity-service'

let initialized = false

export function handleAdminNavigation() {
  if (!state.adminPermissions.has('Admin.BasicAccess') || initialized) {
    return
  }
  void updateEntities()
  initialized = true
}
